import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import Dialog, { DialogTitle, DialogContent, DialogActions } from "components/common/Dialog";
import Button from "components/common/Button";
import PageLoader from "components/common/PageLoader";
import TimelineSimple from "components/common/Timeline/TimelineSimple";
import { getClockinHistory } from "api/clockInWorkforce";
import moment from "moment";
import "./TimesheetTab.scss";

function HistoryTimelineModal({ open, onClose, customerId, employeeId }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && customerId && employeeId) {
      fetchHistory();
    }
  }, [open, customerId, employeeId]);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const response = await getClockinHistory(customerId, employeeId);
      if (response?.success && response?.data) {
        // Handle different response formats
        if (Array.isArray(response.data)) {
          setHistory(response.data);
        } else if (response.data.rows) {
          setHistory(response.data.rows);
        }
      } else if (response?.rows) {
        setHistory(response.rows);
      } else if (Array.isArray(response?.data)) {
        setHistory(response.data);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error fetching history:", error);
    } finally {
      setLoading(false);
    }
  };

  const timelineItems = history.map((item) => ({
    id: item.id,
    title: item.action === "enabled" ? "Clock in/out enabled" : "Clock in/out disabled",
    subtitle: moment(item.actionAt).format("MMM DD, YYYY"),
  }));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      size="sm"
      width="464px"
      title={
        <div className="clockin-modal-title">
          <DialogTitle title="Clock in/out enablement history" />
        </div>
      }
      content={
        <DialogContent>
          <Box className="history-modal">
            {loading && <PageLoader />}
            {!loading && history.length > 0 && (
              <Box className="history-modal-timeline">
                <TimelineSimple items={timelineItems} />
              </Box>
            )}
            {!loading && history.length === 0 && <p className="para-body-m-regular">No history available</p>}
          </Box>
        </DialogContent>
      }
      actions={
        <DialogActions>
          <Button label="Done" variant="contained" color="primary" size="large" onClick={onClose} />
        </DialogActions>
      }
    />
  );
}

HistoryTimelineModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
  employeeId: PropTypes.string.isRequired,
};

export default HistoryTimelineModal;
